import script from "./ShopVouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShopVouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./ShopVouchersPage.vue?vue&type=style&index=0&id=11db9ed1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11db9ed1"]])

export default __exports__